import api from '@/api';

const resource = 'gerencial/perfilanoletivo';

export default {
  postPerfilAnoLetivo( data ) {
    return api.post( `${resource}`, data );
  },

  putPerfilAnoLetivo( data ) {
    return api.put( `${resource}/${data.identificadorperfilanoletivo}`, data);
  },
};
